import React, { useReducer } from "react";
import modalReducer from "./modalReducer";
import modalContext from "./modalContext";
import { SHOW_MODAL, HIDE_MODAL,SET_MODAL_TITLE,SET_MODAL_CONTENT } from "../../types";

const ModalState = (props) => {
  const initialState = {
    modalShow: false,
  };

  const [state, dispatch] = useReducer(modalReducer, initialState);

  const showModal = () => {
    dispatch({
      type: SHOW_MODAL,
    });
  };

  const closeModal = () => {
    dispatch({
      type: HIDE_MODAL,
    });
  };
 /* const setModalTitle = (modalTitle) => {
      dispatch({
        type: SET_MODAL_TITLE,
        action: modalTitle
      });
    };
    const setModalContent = (modalContent) => {
        dispatch({
          type: SET_MODAL_CONTENT,
          action:  modalContent
        });
      };*/
  const modalContextInit = (showEditReceiver) => {
    dispatch({
      type: SET_MODAL_CONTENT,
      action:  { showEditReceiver }
    });
  };

  return (
    <modalContext.Provider
      value={{
        modalShow: state.modalShow,
        showModal,
        closeModal,
        showEditReceiver:state.showEditReceiver??null,
        modalContextInit
     }}
    >
      {props.children}
    </modalContext.Provider>
  );
};

export default ModalState;
